module.exports = new __parcel__URL__("board.5d5e74e6.png").toString();